export enum InfoKey {
  PROCESS_OFFER_GROUPS = 'PROCESS_OFFER_GROUPS',
}
